// Route meta helpers for the signatory detail and self routes.
// Callers such as settings recents and favourites invoke title() with no
// context, and the app switcher runs while tenantClaim is still null.

const UNAPPROVED_BADGE = "<span class='rounded bg-orange text-white p-1 mx-2'>! Unapproved</span>";
const APPROVED_BADGE = "<span class='rounded bg-green text-white p-1 mx-2'>Approved</span>";

export function signatoryViewingLatest(context = {}) {
    return context?.router?.currentRoute?.value?.params?.showLatest === "true";
}

export function signatoryDetailTitle(item, context = {}) {
    const badge = signatoryViewingLatest(context) ? UNAPPROVED_BADGE : APPROVED_BADGE;
    return `Employee: ${item?.FirstName} ${item?.LastName} ${badge}`;
}

export function signatorySelfAppSwitcher(user, tenantClaim) {
    if (!user) return false;
    return !!tenantClaim?.signatory && !tenantClaim?.internal;
}
